module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-2-photo-6-ca9548824b228f069911f5e5194f9a60.webp";